import React                      from 'react';
import { Observe }                from 'rewire-core';
import { WithStyle }              from 'rewire-ui';
import classNames                 from 'classnames';
import { Theme }                  from '../utility/styles';
import{ InfoPanelContext }        from './InfoPanel';
import { withStyles }             from '../utility/styles';

const styles = (_theme: Theme) => ({
  infoPanelContentRoot: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
  },
  infoPanelContentRootMinimized: {
    display: 'none',
  },
});

interface IInfoPanelContentProps {
  classes?: any;
}

export type InfoPanelContentProps = WithStyle<ReturnType<typeof styles>, IInfoPanelContentProps>;

class InfoPanelContent extends React.Component<InfoPanelContentProps> {
  constructor(props: InfoPanelContentProps) {
    super(props);
  }

  render() {
    const { classes, children } = this.props;

    return (
      <InfoPanelContext.Consumer>
        {({isOpenInfoPanel}) => (
          <Observe render={() => (
            <div className={classNames(classes.infoPanelContentRoot, !isOpenInfoPanel ? classes.infoPanelContentRootMinimized : '')}>
              {children}
            </div>
          )} />
        )}
      </InfoPanelContext.Consumer>
    );
  }
}

export default withStyles<IInfoPanelContentProps>(styles, InfoPanelContent);
